import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { User } from '../models/user';
import { AppSettings } from '../providers/app-settings';

@Injectable()
export class UserService {

  private userApiUrl: string;

  constructor(public http: Http, private appSettings: AppSettings) {
    this.userApiUrl = this.appSettings.DB_API_ENDPOINT + 'users/';
  }

  private getDataInJson(res: Response) {
    return res.json();
  }

  public getAllUsers(): Promise<any> {
    return  this.http.get(this.userApiUrl, this.appSettings.apiOptions)
              .toPromise()
              .then(this.getDataInJson);
  }

  public listUsersByRole(role): Promise<any> {
    return this.http.get(this.userApiUrl + 'roles/' + role, this.appSettings.apiOptions)
              .toPromise()
              .then(this.getDataInJson);
  }

  public addUser(newUser: User): Promise<any> {
    return this.http.post(this.userApiUrl, newUser, this.appSettings.apiOptions)
                .toPromise()
                .then(this.getDataInJson);
  }

  public delUser(id): Observable<any> {
    return this.http.delete(this.userApiUrl + id, this.appSettings.apiOptions);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/user.service.ts